import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from './Constants';
import visionImg from './vision-mission.png';
import diagnosticImg from './About_Image2.jpg'; // Add your image here
import './Aboutus.css';
import PublicHeader from './PublicHeader';

const Aboutus = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const token = localStorage.getItem('authToken');
  //   (async () => {
  //     try {
  //       const res = await fetch(`${BASE_URL}profile`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       const data = await res.json();
  //       setUser(data.profile?.is_admin);
  //     } catch (err) {
  //       setError(err.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   })();
  // }, []);

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) setIsSidebarOpen(v => !v);
  };

  return (
    <div className="page-wrapper">
      <PublicHeader />
      {/* <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} /> */}
      <div className="page-container">
        {/* <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} /> */}

        {/* <section className="about-hero text-center text-white">
          <div className="hero-overlay" />
          <h1 className="hero-title">
            <br/>
            Vijaya Diagnostic Centre Limited is one of India’s Leading Diagnostic Centre Networks.
          </h1>
        </section> */}

         <section className="container my-5">
          <br></br>
               <br></br>
          <h2 className="section-title text-teal"> Vijaya Diagnostic Centre Limited is one of India’s Leading Diagnostic Centre Networks.</h2>
<h2/></section>
        <section className="container about-lead">
          <p>
            We are a health-first diagnostic center that has 125 state-of-the-art diagnostic centers located in 20 Indian cities. All the diagnostic centres brandishing our banner have NABL-certified diagnostic labs. Each diagnostic centre is headed by India’s best certified, skilled and experienced personnel. We have an in-house team that consists of 2200+ professionals. Our in-house team consists of India’s top pathologists, radiologists, and microbiologists. We periodically send a small team of our in-house healthcare professionals to every diagnostic centre scattered all over India to train and retrain the professionals at that centre. This team of healthcare professionals are also sent occasionally without prior notice to ensure that our diagnostic centres are upholding the quality standards we have set to ensure the deliverance of international-grade diagnostic services.
          </p>
        </section>

        <section className="container my-5">
          <h2 className="section-title text-teal">About Us</h2>
          <div className="row">
            <div className="col-md-6">
              <p>
                The story of Vijaya Diagnostic Centre Limited is much like any other healthcare institution in India. We deliver innovative, comprehensive and high-quality diagnostic services at reasonable rates.
              </p>
              <p>
                Vijaya Diagnostic Centre Limited is the brainchild of Dr. S. Surendranath Reddy. We opened up our doors back in 1981 and for the last 4+ decades; we have had the privilege to become one of the top-rated diagnostic centre chains in India. We are dedicated to people who choose us to avail our quality-assured diagnostic services.
              </p>
              <p>
                Currently, we have more than 155 diagnostic centres in Hyderabad. We also have several branches in: Sangareddy, Warangal, Hanmakonda, Karimnagar, Kurnool, Nizambad, Wanaparthy, Ongole, Pune, Nellore, Tirupathi, Rajahmundry, Visakhapatnam, Kolkata, Gurgaon, Gulbarga, Bhuvanagiri, Bengaluru.
              </p>
            </div>
            <div className="col-md-6 text-center">
              <img src={visionImg} alt="Vision & Mission" className="img-fluid rounded shadow-sm" />
            </div>
          </div>
        </section>

        <section className="container my-5">
          <h2 className="section-title text-teal">Our Values Set Us Apart</h2>
          <div className="row align-items-center">
            <div className="col-md-6">
              <p>
                We help facilitate the timely deliverance of affordable and quality-assured diagnostic care whether during home sample collection or within the secure and safe environment of our diagnostic centers.
              </p>
              <p>
                We also understand the importance of rendering high quality diagnostic services and delivering the findings to our clients so that patients can avail superior medical care for the best outcomes.
              </p>
              <p>
                We hire none but the best professionals to manage our diagnostic centres. Our hiring process is very strict. Certifications and references alone aren’t enough—we prioritize experience and proven skills.
              </p>
              <p>
                We also make sure that our labs, website and app are using the latest technology to maintain accuracy and speed. Our services comply with strict quality control and ethical norms.
              </p>
            </div>
            <div className="col-md-6 text-center">
              <img src={diagnosticImg} alt="Diagnostic Centre" className="img-fluid rounded shadow-sm" />
            </div>
          </div>
        </section>

        <section className="container my-5">
          <h2 className="section-title text-teal">Our Services</h2>
          <div className="row">
            <div className="col-md-6">
              <h5 className="text-primary">Diagnostics Test</h5>
              <p>
                We offer all prominent kinds of diagnostic tests. The tests are performed in an expedited manner so that you have your hands on the test results in the shortest possible time. Our lab test packages are reasonably priced. All of our labs are NABL certified and supported by 200+ radiologists, microbiologists, and pathologists.
              </p>
            </div>
            <div className="col-md-6">
              <h5 className="text-primary">Corporate Wellness Solutions</h5>
              <p>
                Vijaya Diagnostic Centre Limited also provides Corporate Wellness solutions consisting of onsite and offsite health check-ups. We serve over 400 multinational corporations, helping ensure their workforce is in peak health—boosting productivity significantly.
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Aboutus;
